import DeleteIcon from "@mui/icons-material/DeleteOutlineRounded";
import EditIcon from "@mui/icons-material/EditOutlined";
import { Avatar, Button, Card, CardContent, CardHeader, IconButton, Stack, Typography } from "@mui/material";
import { useState } from "react";
import useDefinedContext from "@entrilia/shared/hooks/useDefinedContext";
import type { ApprovalStep } from "../../../../api/types/workflowTypes";
import ApprovalConfigurationContext from "./ApprovalConfigurationContext";
import { startEditingStepAction } from "./approvalConfigurationState";
import ApprovalRuleCard from "./ApprovalRuleCard";
import DeleteApprovalStepDialog from "./DeleteApprovalStepDialog";

interface Props {
  approvalStep: ApprovalStep;
  stepIndex: number;
}

const ApprovalStepCard = ({ approvalStep, stepIndex }: Props) => {
  const { hasEditPermissions, setState } = useDefinedContext(ApprovalConfigurationContext);

  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);

  return (
    <>
      <Card variant="outlined">
        <CardHeader
          sx={{ pb: 1 }}
          avatar={
            <Avatar variant="rounded" sx={{ height: 24, width: 24, fontSize: 11, fontWeight: 500 }}>
              {stepIndex + 1}
            </Avatar>
          }
          title={<Typography variant="subtitle1">{approvalStep.name}</Typography>}
          action={
            hasEditPermissions ? (
              <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
                <Button
                  variant="outlined"
                  color="secondary"
                  startIcon={<EditIcon />}
                  onClick={() => setState(startEditingStepAction(approvalStep, stepIndex))}
                >
                  Edit
                </Button>
                <IconButton color="error" onClick={() => setIsDeleteDialogOpen(true)}>
                  <DeleteIcon />
                </IconButton>
              </Stack>
            ) : undefined
          }
        />

        <CardContent sx={{ pt: 1 }}>
          <Stack spacing={1}>
            {approvalStep.rules.map((rule, index) => (
              // eslint-disable-next-line @eslint-react/no-array-index-key
              <ApprovalRuleCard key={index} approvalRule={rule} />
            ))}
          </Stack>
        </CardContent>
      </Card>
      <DeleteApprovalStepDialog
        approvalStepName={approvalStep.name}
        open={isDeleteDialogOpen}
        onClose={() => setIsDeleteDialogOpen(false)}
      />
    </>
  );
};

export default ApprovalStepCard;
